// useCuentasXL - Sprint 44 Fase 3 Vista 8.
// Hook lista de cuentas contables con filtros (tipo, activo, q, solo_hojas).
// msg auto-dismiss 4s. Reusa contabilidadService legacy.
import { useCallback, useEffect, useRef, useState } from 'react';
import * as svc from '../services/contabilidadService';

const MSG_AUTO_DISMISS_MS = 4000;

export default function useCuentasXL() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [tipo, setTipo] = useState('');
  const [activo, setActivo] = useState('true');
  const [q, setQ] = useState('');
  const [solo_hojas, setSoloHojas] = useState(false);
  const [msg, setMsg] = useState(null);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const r = await svc.listCuentas({ tipo, activo, q, solo_hojas });
      setItems(r || []);
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar cuentas');
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [tipo, activo, q, solo_hojas]);

  useEffect(() => { load(); }, [load]);

  return {
    items, loading, err,
    tipo, setTipo,
    activo, setActivo,
    q, setQ,
    solo_hojas, setSoloHojas,
    msg, pushMsg, clearMsg: () => setMsg(null),
    load,
  };
}
